var handle_array = ["ando-x-ando-photographs-box","ando-box-iv","zhang-wei","zhang-wei-1","brush-and-gilt-black-goldfish","chant-dune-route","crab-dinner","patrick-bezalel","display-no28","display-no33","do-not-worry-about-tomorrow","erotos-7","fluxion","interiors-hida-takayama","interios-yokosuka-again-18","lost-sun-plaster-resin","love-on-the-left-eye","mirror","mirror-1467","mirror1402","mirror1467","overgrown","my-first-doll","nie","odysseus","residue-of-series-4","series-4","six-small-shrimps","sunday","tendre-et-cruel","the-origin-the-tree-and-me-the-unborn","those-flowers-so-beautiful","untitled","product","living-water","mountain-1-faith-series","mountain-2-faith-series","mountain-3-faith-series","remains-of-a-butterfly-i","swelter","the-ocean-s-whisper-to-me","tiny-bubbles"];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '';
 var display_call_for_price = 1;
 var call_for_price_label = 'Ask for Price';
 var css_style_button='background-color: #808080;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this fields.';
 var error_email_label='Please fill out valid this fields.';
 var error_phone_label = 'Please fill out valid this fields.';
 var error_comment_label = 'Please fill out this fields.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Ask for Price';
 var required_field='name,email,comment';
 var contact_form_heading='Ask for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
